import styled from 'styled-components';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';

export const ToggleButton = styled(Button)(({ theme }) => ({
  '&:not(.disabled):active, &[aria-pressed=true]': {
    backgroundColor: theme.colors.primary['100'],

    '&:not(.disabled):focus': {
      background: theme.colors.primary['100'],
    },
  },
}));
